import React, { useState, useEffect } from 'react';
import './FullScreenLoader.css'; // Reutilizamos tus estilos existentes

const FACT_TIPS = [
  'Analizando facturas emitidas y anuladas...',
  'Sincronizando cuentas por cobrar...',
  'Calculando montos totales en USD...',
  'Organizando historial por año y mes...',
  'Preparando detalle por cliente y producto...',
  'Verificando integridad de los archivos Parquet...'
];

const FactLoader = ({ message = 'Iniciando Facturación...', progress = 0 }) => {
  const [currentTipIndex, setCurrentTipIndex] = useState(0);
  const progressPercent = Math.min(Math.max(progress, 0), 100);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTipIndex((prev) => (prev + 1) % FACT_TIPS.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fullscreen-loader-overlay fact-theme">
      <div className="loader-content">
        {/* Spinner Dual con color distintivo para Facturación (opcional mediante CSS) */}
        <div className="loader-spinner-dual">
          <div className="spinner-ring outer"></div>
          <div className="spinner-ring inner"></div>
        </div>

        {/* Mensaje dinámico que viene del Contexto */}
        <h2 className="loader-main-message">{message}</h2>

        {/* Barra de Progreso */}
        <div className="progress-container">
          <div className="progress-bar-bg">
            <div 
              className="progress-bar-fill" 
              style={{ 
                width: `${progressPercent}%`,
                transition: 'width 0.4s ease-out' 
              }}
            >
              <span className="progress-text">{Math.round(progressPercent)}%</span>
            </div>
          </div>
        </div>

        {/* Tips de Facturación */}
        <p className="loader-tip fade-in-out" key={currentTipIndex}>
          {FACT_TIPS[currentTipIndex]}
        </p>

        <div className="status-dots">
          <div className="dot active"></div>
          <div className="dot active"></div>
          <div className="dot"></div>
        </div>
      </div>
    </div>
  );
};

export default FactLoader;